require('es6-promise').polyfill(); // for IE

require('./ng-admin/Main/MainModule');
require('./ng-admin/Crud/CrudModule');

var Factory = require('admin-config/lib/Factory');

var factory = angular.module('AdminDescriptionModule', []);
factory.constant('AdminDescription', new Factory());

var ngadmin = angular.module('ng-admin', ['ui.select', 'main', 'crud', 'AdminDescriptionModule']);
ngadmin.config(["NgAdminConfigurationProvider", "AdminDescription", function(NgAdminConfigurationProvider, AdminDescription) {
    NgAdminConfigurationProvider.setAdminDescription(AdminDescription);
}]);

ngadmin.config(["uiSelectConfig", function(uiSelectConfig) {
    uiSelectConfig.theme = 'bootstrap';
}]);



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin.js
 **/